import PropTypes from 'prop-types';
import styles from './Stack.module.css';

/**
 * Stack - Flexbox layout container for vertical or horizontal stacking
 * Primary layout primitive for spacing and alignment
 */
export function Stack({
  children,
  direction = 'column',
  gap = 4,
  align = 'stretch',
  justify = 'flex-start',
  wrap = false,
  fullWidth = false,
  fullHeight = false,
  className = '',
  ...props
}) {
  const classNames = [
    styles.stack,
    styles[direction],
    styles[`gap-${gap}`],
    styles[`align-${align}`],
    styles[`justify-${justify}`],
    wrap && styles.wrap,
    fullWidth && styles.fullWidth,
    fullHeight && styles.fullHeight,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={classNames} {...props}>
      {children}
    </div>
  );
}

Stack.propTypes = {
  children: PropTypes.node.isRequired,
  direction: PropTypes.oneOf(['column', 'row']),
  gap: PropTypes.oneOf([0, 1, 2, 3, 4, 5, 6, 8, 10, 12, 16]),
  align: PropTypes.oneOf(['stretch', 'flex-start', 'center', 'flex-end', 'baseline']),
  justify: PropTypes.oneOf(['flex-start', 'center', 'flex-end', 'space-between', 'space-around', 'space-evenly']),
  wrap: PropTypes.bool,
  fullWidth: PropTypes.bool,
  fullHeight: PropTypes.bool,
  className: PropTypes.string,
};

export default Stack;
